import { formatHelper } from "helper/format";
import _get from "lodash.get";
import { pickKycFromOnboarding } from "helper/ckycPrefill";
import { readCkycVerificationFromDetails } from "helper/kycDocumentUpload";

const PHCOnboardingParser = {};

PHCOnboardingParser.onboardingData = (res) => {
  if (res && res.response) {
    res = res.response;
  }

  if (res && res.result) {
    res = res.result;
  }

  if (!res || !Object.keys(res).length) {
    return {};
  }

  const kyc = pickKycFromOnboarding(res);

  return {
    currentStage: _get(res, "currentOnboardingStage", null),
    isOnboardingCompleted: _get(res, "isOnboardingCompleted", null),
    riskProfileId: _get(res, "riskProfileId", null),
    riskProfileName: _get(res, "riskProfileName", null),
    panNumber: kyc.panNumber || null,
    dateOfBirth: kyc.dateOfBirth || null,
    aadharNumber: kyc.aadharNumber || null,
    isManualKYC: _get(res, "isManualKYC", null),
    isPanUploaded: _get(res, "isPanUploaded", null),
    isAadhaarFrontUploaded: _get(res, "isAadhaarFrontUploaded", null),
    isAadhaarBackUploaded:
      _get(res, "isAadhaarBackUploaded", null) ||
      _get(res, "isAadharBackUploaded", null) ||
      _get(res, "aadharCardBackUploaded", null) ||
      _get(res, "aadhaarCardBackUploaded", null),
    documentStatus: _get(res, "documentStatus", null),
    ...readCkycVerificationFromDetails(res),
    duplicateStages: _get(res, "duplicateStages", null),
    portfolioId: _get(res, "portfolioId", null),
    CKYCDone: _get(res, "CKYCDone", null),
    isBroker: _get(res, "isBroker", null),
    isAccountHolder: _get(res, "isAccountHolder", null),
    consentId: _get(res, "consentId", null),
    redirectUrl: _get(res, "redirectUrl", null),
    affiliationId: _get(res, "affiliationId", null),
  };
};

export { PHCOnboardingParser };
